/**
 * This error happens in Firefox if it is not allowed to access security keys by the operating
 * system.
 *
 * Note that the check here is somewhat speculative. We have sentry reports of the error being
 * thrown and observed it on a customer device. We've not been able to reproduce the error
 * ourselves, the corresponding setting just doesn't show up in our Windows VMs.
 *
 * @see https://sentry.heylogin.dev/organizations/heylogin/issues/8008
 * @see https://support.heylogin.dev/#ticket/zoom/6152
 */
export default function isWebauthnTransientError(error: unknown) {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    error.message === 'The operation failed for an unknown transient reason'
  );
}
